{
  "ACTIONS": {
    "CONFIRM": "Confirm",
    "CONTINUE": "Nastavi",
    "SUBMIT": "Submit",
    "RETRY": "Pokušaj ponovo",
    "CANCEL": "Cancel",
    "EMPTY": "You have no orders",
    "LOADING_ORDERS": "Pripremamo vaš račun",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Update Cart",
    "EDIT": "Edit",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "Ovaj odjeljak više nije dostupan",
    "ITEM_NOT_FOUND": "Ova stavka više nije dostupna",
    "PROMOTION_NOT_AVAILABLE": "Ova promocija više nije dostupna",
    "REQUIRED": "Required",
    "COMBO": "Kombinacija",
    "INVALID_EMAIL": "Molimo unesite važeću adresu e-pošte",
    "INVALID_PHONE": "Molimo unesite važeći broj telefona",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "Došlo je do greške pri učitavanju ovog stola. Molimo pokušajte ponovo.",
    "TABLE_NOT_FOUND": "Nismo mogli pronaći ovaj sto. Molimo ponovo skenirajte QR kod."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Last Name",
    "ROOM_NUMBER": "Room Number",
    "SNACKBAR_TITLE": "Your bill is on the way",
    "PAY_BILL": "Pay bill"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Ukupan broj osoba za stolom",
    "PAYING_FOR": "Ukupan broj osoba za koje plaćate",
    "REMAINING": "Preostali iznos",
    "CHEQUE": "Račun",
    "AMOUNT_PAID": "Plaćeni iznos",
    "DISCOUNT": "Popust",
    "PROMO": "Promo",
    "FEES": "Naknade",
    "PAID_ITEMS": "Plaćene stavke",
    "SPLIT_BILL": "Podijeli račun",
    "EDIT_SPLIT": "Uredi podjelu",
    "PAY_BILL": "Plati račun",
    "SPLIT_TITLE": "Podijelite račun",
    "SPLIT_SUBTITLE": "Odaberite kako želite podijeliti račun",
    "SPLIT_EVENLY": "Podijeli ravnomjerno",
    "CUSTOM_AMOUNT": "Prilagođeni iznos",
    "ADD_CUSTOM_AMOUNT": "Dodaj prilagođeni iznos",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Unesite prilagođeni iznos",
    "PAY_FOR_ITEMS": "Platite svoje stavke",
    "CONFIRM_SELECTION": "Potvrdi izbor",
    "SOMEONE_ELSE_PAYING": "Neko drugi za vašim stolom upravo plaća"
  },
  "COMBO": {
    "ADD_N": "Dodaj {{count}} {{section}}",
    "REMOVE_N": "Ukloni {{count}} {{section}}",
    "CANNOT_PROCEED": "Molimo vas da pratite uputstvo iznad kako biste završili kombinaciju prije nastavka",
    "COMPLETE": "Kombinacija {{combo}} je završena!",
    "ON_ANOTHER_SECTION": "Ovo je dio vaše kombinacije {{section}}"
  },
  "CART": {
    "TITLE": "Cart",
    "RECOMMENDATION": "You may also like",
    "TOTAL": "Total",
    "VIEW": "View cart & Place order",
    "EMPTY": "Empty",
    "PLACE_ORDER": "Place order",
    "ADD_TO_BILL": "Dodaj na račun",
    "PAY_NOW": "Plati sada",
    "OOPS": "Oops",
    "ADD_NEW_VARIANT": "Dodaj još jedno",
    "VARIANT_TITLE": "Predomislili ste se?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "Plaćanje",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "My orders",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "Total",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Order",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "Vaša narudžba nije plaćena",
    "CANCELLED": "Vaša narudžba je otkazana",
    "VOID": "Vaša narudžba je poništena",
    "UPDATED": "Vaša narudžba je ažurirana",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "We'll be with you shortly",
    "HELP": "How can we help?",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "Preskoči",
    "MENU": "Menu",
    "SEARCH": "Search",
    "NO_SEARCH_RESULTS": "No items match your search",
    "SEARCH_OTHER_SECTIONS": "We found matches in other sections",
    "NO_FILTER_RESULTS": "No items match your filters",
    "CLEAR_FILTERS": "Clear filters",
    "NO_SECTIONS": "No sections available",
    "STAFF": "Call staff",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "LANGUAGE": "Language",
    "SELECT_LANGUAGE": "Izaberite jezik",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Charge to my room"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "Unesite vaš vaučer",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "Bakšiš",
    "ADD": "Dodaj bakšiš",
    "PLACEHOLDER": "Unesite iznos bakšiša"
  },
  "LANDING": {
    "CALL_WAITER": "Pozovi konobara",
    "VIEW_BILL": "Pogledaj račun - ",
    "LOADING_BILL": "Učitavanje računa"
  },
  "LOADER": {
    "Heading": "Obrađujemo vaše plaćanje...",
    "Subheading": "Molimo ne zatvarajte ovu stranicu. Potvrđujemo vaše plaćanje i automatski ćemo vas preusmjeriti.",
    "Hint": "Ovo obično traje nekoliko sekundi."
  },
  "NoVoucher": "Vaučer nije dostupan",
  "VoucherDisabled": "Ovaj vaučer je deaktiviran",
  "VoucherExpired": "Ovaj vaučer je istekao",
  "VoucherAlreadyUsed": "Ovaj vaučer je već iskorišćen",
  "VoucherZeroBalance": "Ovaj vaučer ima stanje od 0",
  "VoucherUserLimitReached": "Već ste iskoristili ovaj vaučer",
  "VoucherFirstOrderOnly": "Ovaj vaučer je samo za vašu prvu narudžbu",
  "VoucherNotApplicable": "Ovaj vaučer se ne odnosi na stavke u vašoj narudžbi"
}
